import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e2f64b06"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "app"
};
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
export default {
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    // const isLogin = ref(!!localStorage.getItem('token'))
    const active = ref(route.path);

    // ✅ 计算底部内边距：根据路由meta判断  
    const paddingBottom = computed(() => {
      return route.meta.showTabbar ? '50px' : '0';
    });
    // 监听路由变化，同步导航选中状态 + 更新登录状态（防止退出后未刷新）
    watch(() => route.path, newPath => {
      active.value = newPath;
      // isLogin.value = !!localStorage.getItem('token') // 实时更新登录状态
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view), _unref(route).meta.showTabbar ? (_openBlock(), _createBlock(_component_van_tabbar, {
        key: 0,
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event),
        route: "",
        class: "tabbar"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
          to: "/home",
          icon: "home-o"
        }, {
          default: _withCtx(() => [_createTextVNode("训练计划")]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          to: "/my",
          icon: "user-o"
        }, {
          default: _withCtx(() => [_createTextVNode("我的")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)]);
    };
  }
};